import React from "react";
import localization from "../../../config/localization";
import Logo from "assets/img/logo-black.png";
import {Link} from 'react-router-dom'
import logout from "../../../api-client/core/authentication/logout";
import {request} from "../../../api-client";
import LogoWhite from "../../../assets/img/logo-white.png";
import {Instagram} from "@material-ui/icons";
import HomeIcon from '@material-ui/icons/Home';
import {getStoredUser, homePathGenerator} from "../../../api-client/core/authentication/utils";
import browserHistory from "../../../utils/browserHistory";


class PublicNavBar extends React.Component {

  render() {
    const {publicLogo, showLinks, showPanel, isPlaylist, contentCreatorView} = this.props

    return (
      <nav className={contentCreatorView ? "public-creator-banner" : "transparent-register-banner"} style={{zIndex: 100}}>
        <div style={{ flexGrow:1}}>
          <Link to={getStoredUser() ? homePathGenerator('') : "https://www.bloomclouds.com"} target={getStoredUser() ? "_self" : "_blank"}>
            <img style={{ height: contentCreatorView ? (window.innerWidth > 600 ? 35 : 25) : 35, flexGrow:1, cursor: "pointer"}} src={LogoWhite} alt="Logo Bloomclouds"/>
          </Link>
        </div>
        <div className={"banner-text"} style={(contentCreatorView && (window.innerWidth < 601)) ? {fontSize: "12px"} : {}}>
          <p>{localization.get('bloomclouds.slogan')}</p>
        </div>
        <div className={"side-navbar"}>
        </div>
      </nav>
    )
  }
}

const Logout = () =>
  <a className="navbar-link" onClick={e => {
    e.preventDefault()
    request.authentication.logout()
  }}>{localization.get('logout')}</a>

PublicNavBar.defaultProps = {
  showPanel: true
}

export default PublicNavBar
